var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.75C12.728 15.75 15.75 12.728 15.75 9C15.75 7.62495 15.3389 6.34593 14.6327 5.27918L9.26625 11.242C8.7468 11.8192 7.8726 11.9044 7.25133 11.4385L4.8 9.6C4.46863 9.35145 4.40147 8.88135 4.65 8.55C4.89853 8.21865 5.36863 8.15145 5.7 8.4L8.1513 10.2385L13.6605 4.11716C12.449 2.96038 10.8074 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.728 5.27208 15.75 9 15.75Z",
    fill: "#2DCE89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.5d22eee1acd58bd761b0ad48e6c37fb4.svg";
export { ForwardRef as ReactComponent };